import api from "../../api/index.js";

const state = {
  ViewMember: null,
  Member: null,
};

const getters = {
  memberInfo: (state) => {
    return state.Member;
  },
  viewMember: (state) => {
    return state.ViewMember;
  },
  currentMember: (state) => {
    var _member = localStorage.getItem("Member");
    if (_member != null) {
      state.Member = JSON.parse(_member);
    }
    return state.Member;
  },
};

const actions = {
  GetMemberIndex({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberIndex",
        payload,
        (res) => {
          commit({
            type: "setMemberIndex",
            res: res.Result,
          });
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  GetMemberInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberInfo",
        payload,
        (res) => {
          commit({
            type: "setMember",
            res: res.Result,
          });
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
};

const mutations = {
  setMember(state, payload) {
    state.Member = payload.res;
  },
  setMemberIndex(state, payload) {
    state.ViewMember = payload.res;
    localStorage.setItem("Member", JSON.stringify(payload.res.Member));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
